import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ValidationService } from 'path-shared/services/validation/validation.service';

@Component({
  selector: 'app-form-check-edit-tri',
  templateUrl: './form-check-edit-tri.component.html',
  styleUrls: ['./form-check-edit-tri.component.scss']
})
export class FormCheckEditTriComponent implements OnInit {
  val: boolean;

  @Input() label: string;
  @Input() get value() {
    return this.val;
  } set value(val) {
    this.val = val;
    this.valueChange.emit(this.val);
  }
  @Output() valueChange = new EventEmitter();
  @Input() required: boolean;


  constructor(
    private validation: ValidationService
  ) {
    this.required = false;
  }

  ngOnInit() {
  }


  valid(): boolean {
    if (this.isRequired()) {
      return this.validation.isBoolean(this.value);
    } else {
      return true;
    }

  }

  isRequired() {
    return this.required !== false;
  }

  errorRequired() {
    return this.isRequired() && this.validation.isEmpty(this.value);
  }
}
